import SectionHeader from '../components/SectionHeader';
import { companyDescription } from '../data/content';

function About() {
  return (
    <section className="content-section page-section">
      <SectionHeader label="About Us" title="Learn more about our story" />
      <div className="content-grid">
        <div className="content-card">
          <h3>Who We Are</h3>
          <p>
            {companyDescription}
          </p>
        </div>
        <div className="content-card">
          <h3>Vision</h3>
          <p>
            To be a Trustworthy HR Partner for Corporates in alignment with current HR practices and industry standards.
          </p>
        </div>
        <div className="content-card">
          <h3>Mission</h3>
          <p>
            To deliver ethical and effective HR solutions to Individuals and Managements for their improvement.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
